"use strict";

import { debouncer } from '../../../utils/utils';
import { setMainNavHeight} from '../../_imports/utils/utils.common';

const LINKS_CONTAINER_HOVER_BACKGROUND_TOP_PROPERTY = '--linksContainerHoverBackgroundTop';
const MAIN_NAV_MOBILE_TAB_TRANSITION_PROPERTY = '--mainNavMobileTabTransitionProperty';
const MAIN_NAV_TABS_CONTAINER_TRANSLATE_X_PROPERTY = '--mainNavTabsContainerTranslateX';
const MAIN_NAV_TABS_CONTAINER_WIDTH_PROPERTY = '--mainNavTabsContainerWidth';
const MAIN_NAV_TABS_CONTAINER_HEIGHT_PROPERTY = '--mainNavTabsContainerHeight';

const header = document.querySelector('header');
const headerTop = header.querySelector('.header_top');
const mainNavigationRoot = document.querySelector('[am-main-navigation]');
const mainNavigationContainer = document.querySelector('[am-main-navigation] > .container');
const mainNavigation = mainNavigationRoot.querySelector('.main-navigation');
const navList = mainNavigationRoot.querySelector('.nav-list');
const parentMenuLinks = Array.from(mainNavigation?.querySelectorAll('.parent-menu-link'));
const navigationTabsContainer = mainNavigation?.querySelector('.navigation-tabs');
const navigationTabs = Array.from(navigationTabsContainer?.querySelectorAll('[am-navigation-item~="navigation-tab"]'));
const mobileNavTrigger = mainNavigationRoot?.querySelector('#mobile-nav-trigger');
const mobileSearchTrigger = mainNavigationRoot?.querySelector('#mobile-search-trigger');

const isSimpleNav = headerTop?.classList.contains('simple');

mainNavigationRoot.addEventListener('refreshstyles', () => {
    if (!currentNavigationTab) {
        return;
    }

    const parentMenuLink = parentMenuLinks.find(parent => parent.dataset.navTabIndex === currentNavigationTab.dataset.navTabIndex);

    setTimeout(() => {
        setNavigationTabsContainerStyles(currentNavigationTab, parentMenuLink);
    }, 0);
});

header.addEventListener('disappear', () => {
    header.classList.add('will-disappear');

    setTimeout(() => {
        header.classList.add('disappear');
        header.classList.remove('will-disappear');
    }, 0);
});

header.addEventListener('appear', () => {
    header.classList.remove('disappear');
});

let vueComponentsLoaded = false;
let currentNavigationTab = null;

const setNavigationTabTransitionPropertyToDefault = navigationTab => {
    navigationTab.style.setProperty(MAIN_NAV_MOBILE_TAB_TRANSITION_PROPERTY, '100%');
};

const initVueComponentsToLoad = () => {
    if (vueComponentsLoaded) {
        return;
    }

    vueComponentsLoaded = true;

    navigationTabsContainer.querySelectorAll('[data-component-file-to-load]').forEach(vueComponent => {
        vueComponent.setAttribute('data-component-file', vueComponent.dataset.componentFileToLoad);
    });
};

const setNavigationTabsContainerStyles = (navigationTab = currentNavigationTab, parentMenuLink = null) => {
    if (!navigationTab) {
        closeNav();
        return;
    }

    const parentLink = parentMenuLink ?? parentMenuLinks.find(parent => parent.dataset.navTabIndex === currentNavigationTab.dataset.navTabIndex);

    if (!parentLink) {
        closeNav();
        return;
    }

    const navigationTabBounds = navigationTab.getBoundingClientRect();
    const mainNavigationContainerHorizontalPadding = parseInt(getComputedStyle(mainNavigationContainer).getPropertyValue('padding-left'));
    const offset = isSimpleNav ? 16 : 32;

    let translateX = Math.round(parentLink.getBoundingClientRect().left - mainNavigation.getBoundingClientRect().left - offset);
    let width = Math.floor(navigationTabBounds.width);
    const height = Math.floor(navigationTabBounds.height);

    if (translateX + width > window.innerWidth) {
        translateX = window.innerWidth - width - mainNavigationContainerHorizontalPadding;
    }

    if (navigationTab.classList.contains('tab-panel-max-width')) {
        width = mainNavigation.getBoundingClientRect().width;
        translateX = 0;
    }

    navigationTabsContainer.style.setProperty(MAIN_NAV_TABS_CONTAINER_TRANSLATE_X_PROPERTY, `${translateX}px`);
    navigationTabsContainer.style.setProperty(MAIN_NAV_TABS_CONTAINER_WIDTH_PROPERTY, `${width}px`);
    navigationTabsContainer.style.setProperty(MAIN_NAV_TABS_CONTAINER_HEIGHT_PROPERTY, `${height}px`);
};

const initNavigationTabs = () => {
    mainNavigationRoot?.addEventListener('mouseout', e => {
        const target = e.toElement || e.relatedTarget;
        
        if (!mainNavigationRoot.contains(target)
            && mainNavigationRoot !== target) {
            closeDesktopNav();
        }
    });

    parentMenuLinks?.forEach(parentMenuLink => {
        const triggerSubmenu = parentMenuLink.querySelector('.trigger-submenu');

        if (!triggerSubmenu) {
            return;
        }

        parentMenuLink.addEventListener('mouseover', () => openDesktopNavTab(parentMenuLink));
        
        const hasLink = triggerSubmenu.hasAttribute('href');
        
        if (!hasLink) {
            parentMenuLink.addEventListener('click', () => {
                if (window.innerWidth > 1024) {
                    if (isNavOpen()
                        && parentMenuLink.classList.contains('open')) {
                        closeDesktopNav();
                    } else {
                        openDesktopNavTab(parentMenuLink);
                    }

                    return;
                }
        
                const navigationTab = navigationTabs.find(tab => tab.dataset.navTabIndex === parentMenuLink.dataset.navTabIndex);
        
                if (!navigationTab) {
                    return;
                }
    
                navList.classList.add('away');
        
                navigationTab.style.setProperty(MAIN_NAV_MOBILE_TAB_TRANSITION_PROPERTY, '0');
            });
        }
    });

    initVueComponentsToLoad();
};

const initDesktopLinksContainerHover = () => {
    mainNavigation?.querySelectorAll('[am-navigation-item~="links-container"][am-link-container-theme~="blue-rectangle"]').forEach(linkContainer => {
        linkContainer.addEventListener('mouseout', () => {
            linkContainer.classList.remove('active');
        });

        linkContainer.querySelectorAll('[am-navigation-item~="link"]').forEach(link => {
            link.addEventListener('mouseover', () => {
                if (window.innerWidth <= 1024) {
                    return;
                }

                linkContainer.classList.add('active');

                linkContainer.style.setProperty(LINKS_CONTAINER_HOVER_BACKGROUND_TOP_PROPERTY, `${link.getBoundingClientRect().top - linkContainer.getBoundingClientRect().top + 7}px`);
            });

            link.addEventListener('mouseout', e => {
                if (window.innerWidth <= 1024) {
                    return;
                }

                const target = e.toElement || e.relatedTarget;

                if (!linkContainer.contains(target)
                    || linkContainer === target) {
                    linkContainer.classList.remove('active');
                }
            });
        });
    });
};

const initMobileNavigationTabBackButton = () => {
    navigationTabs.forEach(navigationTab => {
        const backButton = navigationTab.querySelector('.back-button');
    
        backButton.addEventListener('click', () => {
            navList?.classList.remove('away');
            setNavigationTabTransitionPropertyToDefault(navigationTab);
        });
    });
};

const initMobileNavTriggerClick = () => {
    mobileNavTrigger?.addEventListener('click', () => {
        mobileSearchTrigger.checked = false;
        document.documentElement.classList.remove('mobile-nav-open');
        document.documentElement.classList.remove('compact-nav-banner-mobile-is-visible');

        if (mobileNavTrigger.checked) {
            if(document.querySelector('header .compact-nav-banner-container.banner-mobile [am-compact-nav-banner]')) {
                document.documentElement.classList.add('compact-nav-banner-mobile-is-visible');
            }

            document.documentElement.classList.add('mobile-nav-open');
            
            document.querySelector('body').classList.remove('search-active');
            document.querySelector('.navigation-tabs .tabs #search-tab')?.classList.remove('open');
            document.querySelector('nav.main-navigation')?.classList.remove('open');
            
            return;
        }
        
        closeMobileNav();
    });
};

const initLinksClick = () => {
    mainNavigation.querySelectorAll('[am-navigation-item="link"]').forEach(link => {
        link.addEventListener('click', closeNav);
    });
};

const initMobileSearchTriggerClick = () => {
    mobileSearchTrigger?.addEventListener('click', () => {
        mobileNavTrigger.checked = false;
        document.documentElement.classList.remove('mobile-nav-open');
        document.documentElement.classList.remove('compact-nav-banner-mobile-is-visible');

        if (mobileSearchTrigger.checked) {
            if(document.querySelector('header .compact-nav-banner-container.banner-mobile [am-compact-nav-banner]')) {
                document.documentElement.classList.add('compact-nav-banner-mobile-is-visible');
            }

            document.documentElement.classList.add('mobile-nav-open');
            document.querySelector('body').classList.add('search-active');

            document.querySelector('.navigation-tabs .tabs #search-tab')?.classList.add('open');
            document.querySelector('nav.main-navigation')?.classList.add('open');
            
            return;
        }

        closeMobileNav();
    });
};

const openDesktopNav = () => {
    if (!mainNavigation.classList.contains('open')) {
        mainNavigation.classList.add('open');
        
        const routine = () => {
            window.requestAnimationFrame(() => {
                setNavigationTabsContainerStyles();
        
                if (mainNavigation.classList.contains('open')) {
                    routine();
                }
            });
        };
        
        routine();      
    }
};

const openDesktopNavTab = parentMenuLink => {
    document.querySelector('#header-content').classList.remove('search-active');
    document.querySelector('body').classList.remove('search-active');
    
    if (window.innerWidth < 1024
        || !navigationTabsContainer) {
        return;
    }

    const triggerSubmenu = parentMenuLink.querySelector('.trigger-submenu');

    if (!triggerSubmenu) {
        return;
    }

    const hasLink = triggerSubmenu.hasAttribute('href');
    const navigationTab = navigationTabs.find(tab => tab.dataset.navTabIndex === parentMenuLink.dataset.navTabIndex);

    parentMenuLinks.forEach(link => link.classList.remove('open'));

    if (hasLink) {
        closeDesktopNav();

        return;
    }

    setNavigationTabsContainerStyles(navigationTab, parentMenuLink);

    const currentNavigationTabIndex = parseInt(navigationTab.dataset.navTabIndex);

    navigationTabs.forEach(tab => {
        tab.classList.remove('right-tab', 'left-tab');

        if (tab !== navigationTab) {
            tab.classList.remove('open');

            if (parseInt(tab.dataset.navTabIndex) < currentNavigationTabIndex) {
                tab.classList.add('left-tab');
            } else {
                tab.classList.add('right-tab');
            }
        }
    });

    currentNavigationTab = navigationTab;
    
    window.requestAnimationFrame(() => {
        if (parentMenuLink?.dataset?.navTabIndex === currentNavigationTab?.dataset?.navTabIndex) {
            parentMenuLink.classList.add('open');
            navigationTab.classList.add('open');

            const navigationSearch = navigationTab.querySelector('[am-navigation-item="navigation-search"]');

            if (navigationSearch) {
                document.querySelector('#header-content').classList.add('search-active');
                document.querySelector('body').classList.add('search-active');
                
                setTimeout(() => {
                    navigationSearch.querySelector('.navigation-search-box')?.focus();
                }, 0);
            }
        }

        setTimeout(openDesktopNav, 0);
    });
};

const closeDesktopNav = () => {
    if (window.innerWidth <= 1024) {
        return;
    }

    mainNavigation.classList.remove('open');

    document.querySelector('#header-content').classList.remove('search-active');
    document.querySelector('body').classList.remove('search-active');

    parentMenuLinks.forEach(link => link.classList.remove('open'));

    navigationTabs.forEach(tab => {
        tab.classList.remove('open', 'right-tab', 'left-tab');
    });

    currentNavigationTab = null;
};

const closeMobileNav = () => {
    mobileNavTrigger.checked = false;
    mobileSearchTrigger.checked = false;
    navList?.classList.remove('away');
    
    document.documentElement.classList.remove('mobile-nav-open');
    document.documentElement.classList.remove('compact-nav-banner-mobile-is-visible');
    
    document.querySelector('body').classList.remove('search-active');
    document.querySelector('.navigation-tabs .tabs #search-tab')?.classList.remove('open');
    document.querySelector('nav.main-navigation')?.classList.remove('open');
    
    navigationTabs.forEach(navigationTab => {
        setNavigationTabTransitionPropertyToDefault(navigationTab);
    });
};

const closeNav = () => {
    if (window.innerWidth > 1024) {
        closeDesktopNav();
    } else {
        closeMobileNav();
    }
};

const isNavOpen = () => {
    return mainNavigation.classList.contains('open');
};

const hasNoHeader = () => {
    return  !document.querySelector('.header_top');
}

window.addEventListener('resize', () => {
    mainNavigation.classList.add('updating');

    setTimeout(() => {
        mainNavigation.classList.remove('updating');
    }, 0);
});

window.addEventListener('resize', debouncer(() => {
    setMainNavHeight();
    
    if (window.innerWidth > 1024) {
        if (document.documentElement.classList.contains('mobile-nav-open')) {
            closeMobileNav();
        }
    }
}, 500));

if (hasNoHeader()) {
    document.documentElement.classList.add('no-header');
    setMainNavHeight();
}

initNavigationTabs();
initDesktopLinksContainerHover();
initMobileNavigationTabBackButton();
initMobileNavTriggerClick();
initMobileSearchTriggerClick();
initLinksClick();